import isExperienceEditor from '@utils/is-experience-editor';

const DISABLED_CLASS_NAME = '-disabled';

export default class StoryCarousel {
    constructor({ $el }) {
        this.$el = $el;

        this.$slider = this.$el.find('[data-region="slider"]');

        this.$pauseLabel = this.$el.find('[data-label="pause"]');
        this.$playLabel = this.$el.find('[data-label="play"]');

        this.$next = this.$el.find('[data-control="next"]');
        this.$prev = this.$el.find('[data-control="prev"]');
        this.$playPause = this.$el.find('[data-control="playPause"]');

        this.init();
    }

    init() {
        this.setupSlider();
        this.setupListeners();
    }

    onBeforeChange({ slideCount }, nextSlide) {
        this.$prev.removeAttr('aria-disabled').removeClass(DISABLED_CLASS_NAME);
        this.$next.removeAttr('aria-disabled').removeClass(DISABLED_CLASS_NAME);

        if(nextSlide === 0) {
            this.$prev.attr('aria-disabled', true).addClass(DISABLED_CLASS_NAME);
        } else if ((nextSlide + 1) === slideCount) {
            this.$next.attr('aria-disabled', true).addClass(DISABLED_CLASS_NAME);
        }
    }

    onNext() {
        this.$slider.slick('slickNext');
    }

    onPrev() {
        this.$slider.slick('slickPrev');
    }

    onPlayPause() {
        const slick = this.$slider.slick('getSlick');
        const paused = slick.paused;

        paused ? this.play() : this.pause();
    }

    pause() {
        this.$slider.slick('slickPause');
        this.$playPause.removeClass('-pause').addClass('-play');
    }

    play() {
        this.$slider.slick('slickPlay');
        this.$playPause.removeClass('-play').addClass('-pause');
    }

    setupSlider() {
        this.$slider.slick({
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000,
            infinite: false,
            fade: true,
            pauseOnHover: false,
            speed: 1000,
        });

        this.$prev.attr('aria-disabled', true).addClass(DISABLED_CLASS_NAME);
    }

    setupListeners() {
        this.$next.on('click', () => this.onNext());
        this.$prev.on('click', () => this.onPrev());
        this.$playPause.on('click', () => this.onPlayPause());
        this.$slider.on('beforeChange', (...[,slick,,nextSlide]) => this.onBeforeChange(slick, nextSlide));
        this.$slider.on('focus', 'a[href], button, input, textarea, select, details,[tabindex]:not([tabindex="-1"])', () => this.pause());
    }
}

$('.js-story-carousel').each(function() {
    const $el = $(this);
    if(!isExperienceEditor) {
        new StoryCarousel({
            $el
        });
    } else {
        $el.addClass('-isExperienceEditor');
    }
});
